const APP_VERSION = '1.10.13';

export default APP_VERSION;
